import styled from 'styled-components';
import { LARGE, SubTitle, BodyText, EXTRA_LARGE } from '@minerva-analytics/pantheon';
import { SKY_BLUE, SALMON } from '../../theme';
import AboutBackgroundImg from '../../assets/BG_image.png';

const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 85%;
  margin: 0 auto;

  @media (max-width: ${EXTRA_LARGE}) {
    width: 90%;
    justify-content: center;
  }
`;

const AboutHeader = styled.div`
  margin-top: 5rem;
  display: flex;
  flex-direction: column;

  @media (max-width: ${LARGE}) {
    margin-top: 0;
  }
`;

const AboutSubHeader = styled(SubTitle)`
  &&&{
    color: ${SKY_BLUE};
    font-weight: 400;
    text-transform: uppercase;
    font-size: 1.5rem;
    margin-top: 0rem;

    @media (max-width: ${LARGE}) {
      margin: 0;
    }
  }
`;

const AboutSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 4rem 0;
  align-items: center;

  @media (max-width: ${LARGE}) {
    flex-direction: column;
  }
`;

const TextSection = styled.div`
  max-width: 750px;
  flex-direction: column;

  @media (max-width: ${EXTRA_LARGE}) {
    max-width: 650px;
  }

  @media (max-width: ${LARGE}) {
    max-width: unset;
  }
`;

const AboutImage = styled.img`
  width: 30rem;
  height: 100%;

  @media (max-width: ${EXTRA_LARGE}) {
    width: 28rem;
  }

  @media (max-width: ${LARGE}) {
    width: 70%;
    margin-top: 2rem;
  }
`;

const SecondAboutSection = styled.div`
  background-color: ${SALMON};
  background-image: url(${AboutBackgroundImg});
  background-size: 40%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row-reverse;
  padding: 4rem 0;
  width: 100vw;
  margin-left: 50%;
  transform: translateX(-50%);
  align-items: center;


  @media (max-width: ${EXTRA_LARGE}) {
    background-size: 50%;
  }

  @media (max-width: ${LARGE}) {
    background-image: none;
    background-size: unset;
    justify-content: center;
  }
`;

const SecondTextSection = styled.div`
  max-width: 750px;
  flex-direction: column;
  margin-right: 5rem;

  @media (max-width: ${EXTRA_LARGE}) {
    max-width: 650px;
    margin-right: 3rem;
  }

  @media (max-width: ${LARGE}) {
    max-width: unset;
    flex-direction: column;
    margin-right: 0;
    width: 85%;
  }
`;

const WhiteBodyText = styled(BodyText)`
  &&&{
    color: white;
  }
`;

const WhiteSubTitle = styled(SubTitle)`
  &&&{
    color: white;
  }
`;

export { 
  AboutContainer, 
  AboutHeader,
  AboutSubHeader,
  TextSection,
  AboutSection,
  AboutImage,
  SecondAboutSection,
  WhiteBodyText,
  WhiteSubTitle,
  SecondTextSection
};
